"use client";

import { EditableProfileWrapper } from "../EditableProfileWrapper";

import { ChangePasswordForm } from "../forms/change-password-form/ChangePasswordForm";
import { PASSWORD_PLACEHOLDER } from "./constants";
import { useGetHeaders } from "./useGetHeaders";

export const EditableProfilePassword = () => {
    const headers = useGetHeaders();

    const { label, edit, changePassword } = headers;

    return (
        <EditableProfileWrapper
            title={label}
            headers={{
                editButton: edit,
                editButtonAria: changePassword,
            }}
            data={[PASSWORD_PLACEHOLDER]}
        >
            <ChangePasswordForm headers={headers} />
        </EditableProfileWrapper>
    );
};
